module.exports = __webpack_public_path__ + "static/media/gerb-3.32f5451c.png";